'use client';

import { useRef } from 'react';

import { CartService } from '@/services/modules/CartService';

export function useCartService() {
  const ref = useRef<CartService | null>(null);
  if (ref.current === null) {
    ref.current = new CartService();
  }
  return ref.current;
}
